import NameValueView from "../../../../../attribute/NameValueView.js";
const editors = new NameValueView('CustomTextValueRenderer', {
  handleKey: 'canRender'
});
export default {
  getRendererFor: editors.getItemFor
};